/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleInfoEmpty: {
  name: 'circle-info-empty';
  data: string;
} = {
  name: 'circle-info-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.03-2a1 1 0 0 1 .992 1.009l-.044 5a1 1 0 0 1-2-.018l.044-5A1 1 0 0 1 12.03 10ZM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
